import { render } from "./MainBannerVideo.vue?vue&type=template&id=aa18f878"
import script from "./MainBannerVideo.vue?vue&type=script&lang=js"
export * from "./MainBannerVideo.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__